define(['jquery', 'jquery.transit', 'modernizr', 'container'],
    function ($, transit, modernizr, container) {

        return (function () {

            const name = 'legal-layout';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                backToTopStatus: false,
            };

            view.startup = function () {

            };

            view.bind = function () {
                $(window).scroll(function (event) {
                    let ticking = false;

                    if (!ticking) {
                        window.requestAnimationFrame(function () {
                            view.methods.backToTopHandleScroll();
                            ticking = false;
                        });
                    }
                    ticking = true;
                });

                $(view.publicVars.cssId.sectionArrowToTopId).click(function () {
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                });

                $(view.publicVars.cssId.accordion.sectionAccordionLabelCls).click(function () {
                    view.methods.accordion.handle(this);
                });
            };

            view.methods = {
                backToTopHandleScroll: () => {
                    let scroll = $(window).scrollTop();

                    if(scroll < 50 && view.privateVars.backToTopStatus) {
                        $(view.publicVars.cssId.sectionArrowToTopId).fadeOut(100);
                        view.privateVars.backToTopStatus = false;
                    }

                    if(scroll >= 50 && !view.privateVars.backToTopStatus) {
                        $(view.publicVars.cssId.sectionArrowToTopId).fadeIn(100);
                        view.privateVars.backToTopStatus = true;
                    }


                },

                accordion: {
                    handle: (handle) => {
                        const id = $(handle).data('id');

                        if($('#' + view.publicVars.cssId.accordion.sectionAccordionContentCls.substr(1) + id).css('display') == 'block') {
                            $(handle).removeClass(view.publicVars.cssId.accordion.isActiveCls.substr(1));
                            $('#' + view.publicVars.cssId.accordion.sectionAccordionContentCls.substr(1) + id).slideUp(300);
                        } else {
                            $(handle).addClass(view.publicVars.cssId.accordion.isActiveCls.substr(1));
                            $('#' + view.publicVars.cssId.accordion.sectionAccordionContentCls.substr(1) + id).slideDown(300);
                        }
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
